import type { CrudColumnDef } from "@/components/tables/crudColumnDef";
import { sanitizeValuesBeforeSendingToApi } from "@/components/tables/genericCrudTable.utils";
import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export interface UpdatePayloadContext {
  columns: CrudColumnDef[];
  subdomain: string;
  canEditUserRoles: boolean;
  companySubjectId?: string;
  companyId?: string;
  selectedChildCompanySubjectId?: string; // redux state.parent.subjectId
  searchId?: string;
  presetValues: Record<string, any>; // the row being edited (modalPresetValues)
  entityAdapter?: EntityAdapter;
}

export const buildUpdatePayload = (
  values: any,
  ctx: UpdatePayloadContext
): any => {
  let result = sanitizeValuesBeforeSendingToApi(values, ctx.columns);

  if (ctx.entityAdapter?.adjustUpdatePayload) {
    result = ctx.entityAdapter.adjustUpdatePayload(result, values, ctx);
  }

  return result;
};
